export enum NavBarArea {
  Settings,
  Phishing,
}
